/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/196-cloud-upload': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M13.942 6.039a2.5 2.5 0 00-3.085-2.955 3 3 0 00-5.737.075A4 4 0 104 11h2v3h4v-3h3.5a2.5 2.5 0 00.442-4.961zM9 10v3H7v-3H4.5L8 6.5l3.5 3.5H9z"/>'
  }
})
